<header class="flex vcenter">
  <button
    color="grey-light"
    payee-icon-button
    (click)="logout()"
  >
    <payee-icon name="logout-grey"></payee-icon>
  </button>
  <button
    payee-button
    color="grey-light"
    class="name-button"
    [matMenuTriggerFor]="userMenu"
  >
    {{ userName }}
  </button>
  <mat-menu #userMenu="matMenu">
    <button
      mat-menu-item
      (click)="manageMFA()"
    >
      {{ (has2FA ? "USER_PROFILE.DISABLE_2FA" : "USER_PROFILE.ENABLE_2FA") | translate }}
    </button>
  </mat-menu>
</header>
